import { http } from "@/utils/http";
import {
  IAuthAdminPayload,
  IAuthUserPayload,
} from "@/features/auth/auth.types";

export const authService = {
  login(payload: IAuthUserPayload) {
    return http.post("/auth/login", payload);
  },

  bootstrapAdmin(payload: IAuthAdminPayload) {
    return http.post("/auth/bootstrap-admin", payload);
  },
};
